import React, { FC, ReactElement, useState, useEffect } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Formik } from 'formik'
import API from '@aws-amplify/api'

import { makeStyles } from '@material-ui/core/styles'
import { inject, observer } from 'mobx-react'

import { Form } from 'react-bootstrap'
import { Editor } from '@tinymce/tinymce-react'
import Spinner from '../../../Spinner'
import { Prospects as ProspectsStore } from '../../../../stores/prospects'
import { Settings as SettingsStore, Signature } from '../../../../stores/settings'
import LoadingButton from '../../../LoadingButton'
import { ToastTypeEnum } from '../../Toasts'

interface Props extends RouteComponentProps {
  prospects?: ProspectsStore
  settings?: SettingsStore
  signatures?: Signature[]
}
const useStyles = makeStyles(() => ({
  '.signature': {
    padding: '15px',
  },
}))

const Signatures: FC<Props> = ({ settings }) => {
  const [isLoading, setIsLoading] = useState(false)
  const classes = useStyles()

  const updateSignatures = async (values: { signature: string }): Promise<void> => {
    let myInit = {}
    if (values.signature) {
      const payload = {
        signatures: settings?.signatures?.map((s, index) => ({
          id: s.id,
          signature: index === 0 ? values.signature : s.signature,
        })),
      }
      myInit = {
        body: payload,
      }
    } else {
      setIsLoading(false)
      return
    }

    try {
      setIsLoading(true)
      const response: { signatures: Signature[] } = await API.put(
        'mav-outlook-api',
        '/users/signatures',
        myInit,
      )

      settings?.setSignatures(response.signatures)

      settings?.pushToToasts({
        type: ToastTypeEnum.INFO,
        message: 'Your Signature has been updated',
      })

      setIsLoading(false)
    } catch (e) {
      console.error(e)

      settings?.pushToToasts({
        type: ToastTypeEnum.ERROR,
        message: "Couldn't modify signatures",
      })
      setIsLoading(false)
    }
  }
  const handleTextChange = (
    event: {
      target: {
        getContent: () => string
      }
    },
    setFieldValue: (field: string, value: string) => void,
    field: string,
  ): void => {
    const str = event.target.getContent()
    console.log(field, str)
    setFieldValue(field, str)
  }
  useEffect(() => {
    settings?.getSignatures()
  }, [])
  return (
    <div className="w-100">
      {!settings?.isLoading ? (
        <div className={classes['.signature']}>
          <Formik
            onSubmit={updateSignatures}
            initialValues={{ signature: settings?.signatures[0]?.signature || '' }}
          >
            {({ handleSubmit, setFieldValue, values, dirty }): ReactElement => (
              <Form noValidate onSubmit={handleSubmit}>
                <Form.Group controlId="signature">
                  <Editor
                    textareaName="Signature"
                    apiKey="dc71buijbp92lbdveqijzgigj9gxfosqm6li1pr7o1s20vds"
                    value={values.signature}
                    id="signature"
                    init={{
                      browser_spellcheck: true,
                      branding: false,
                      forced_root_block: false,
                      contextmenu: false,
                      height: 100,
                      menu: {
                        custom: {
                          title: 'Custom Menu',
                          items: 'undo redo myCustomMenuItem',
                        },
                      },
                      menubar: false,
                      plugins: ['link', 'searchreplace', 'paste contextmenu', 'image'],
                      toolbar:
                        'bold italic underline forecolor image | fontsizeselect fontselect | link',
                      file_picker_types: 'image',
                      setup: (editor): void => {
                        if (settings?.signatures) {
                          editor.on('init', () => {
                            editor.setContent(settings?.signatures[0].signature)
                          })
                        }
                      },
                    }}
                    onEditorChange={(value): void => {
                      setFieldValue('signature', value)
                    }}
                    onChange={(value): void => {
                      console.log('value =>', value)
                      handleTextChange(value, setFieldValue, 'signature')
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <LoadingButton
                    disabled={!dirty}
                    isLoading={isLoading}
                    variant="primary"
                    type="submit"
                  >
                    Save
                  </LoadingButton>
                </Form.Group>
              </Form>
            )}
          </Formik>
        </div>
      ) : (
        <Spinner />
      )}
    </div>
  )
}

export default inject('settings')(withRouter(observer(Signatures)))
